import TagManager from 'react-gtm-module'
const tagManagerArgs = {
  gtmId: 'GTM-T4TNQRP'
}

TagManager.initialize(tagManagerArgs)
